import React, { useState } from 'react'
import { ModalContentWrapper, ModalFooterWarpper, ModalInputBoxWrapper, ModalLabelWrapper } from '../common/ModalStyled'
import { ActionButton, AlertSpan, NextButton } from '../common/CommonStyled'
import { useModalStore } from 'src/stores/ModalStore'
import InputBoxOnChangeValid from '../myInfo/InputBoxOnChangeValid'
import InputBoxOnBlurChildren from '../inputbox/InputBoxOnBlurChildren'
import CountdownTimer from 'src/utils/CountdownTimer'
import { postAuthEmail, putUserUpdate } from 'src/api/User'
import styled from 'styled-components'
import { refetchUser } from 'src/utils/RefetchUser'

const FormInputContainer = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    gap: 5px;
`;

interface Props {
  setEmailState: React.Dispatch<React.SetStateAction<any>>;
}

const AdChangeEmailModalContent = ({setEmailState}:Props) => {
    const modalSetField = useModalStore((state)=>state.setField)
    const [email,setEmail] = useState('')
    const handleEmail = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setIsEmailVaild(true)
        setEmail(e.target.value)
    }
    const [cond3,setCond3] = useState(false)
    const [authCode,setAuthCode] = useState('')
    const [isTimeout,setIsTimeout] = useState(false)
    const [resetTimer,setResetTimer] = useState(0)
    const [isEmailVerify,setIsEmailVerify] = useState(false)
    const [authCodeVerify,setAuthCodeVerify] = useState(true)
    const [inputAuthCode,setInputAuthCode] = useState('')
    const [authCodeValid,setAuthCodeValid] = useState(true)
    const [isEmailVaild,setIsEmailVaild] = useState(true)
    const handleAuthEmail = async (user_email:string) => {
        const response = await postAuthEmail(user_email)
        if(response.status === false){
            setIsEmailVaild(false)
            setAuthCode('')
            setIsEmailVerify(false)
            return
        }
        setAuthCodeVerify(false);
        setAuthCode(response.code.slice(2));

        // 🔥 타이머 리셋!
        setResetTimer((prev) => prev + 1)
        setIsTimeout(false)
    }
    const handleEmailVerify = ()=>{
        if(!authCode) return
        if(inputAuthCode === authCode) {
        setIsEmailVerify(true)
        setAuthCodeValid(true)
        }
        else{
        setIsEmailVerify(false)
        setAuthCodeValid(false)
        }
        setAuthCodeVerify(true)
    }
    const handleChangeEmail = async ()=>{
        const response = await putUserUpdate({
            email:email,
        })
        refetchUser()
        if(response.status === 'OK')
        {
            setEmailState(email)
        }
        else{
            // console.log('이메일 변경실패');
        }
        modalSetField('open',false)
    }
    
    return (
        <ModalContentWrapper style={{marginBottom:'16px'}}>
            <ModalInputBoxWrapper>
            <ModalLabelWrapper>이메일</ModalLabelWrapper>
            <FormInputContainer>
                <InputBoxOnChangeValid 
                    value={email}
                    placeholder='이메일 입력'
                    onChange={handleEmail}
                    lengthRegex={/^.{0,50}$/} lengthSpan='이메일은 최대 50자까지 가능합니다.'
                    regex0={/^[A-Za-z][A-Za-z0-9._%+-]*[A-Za-z0-9]@[A-Za-z0-9.-]+\.[A-Za-z]+$/} regex0Span="이메일 형식에 맞지 않습니다."
                    setCond={setCond3}/>
                    {
                        (authCode ? 
                        <ActionButton disabled={!isTimeout || isEmailVerify || !cond3}onClick={()=>handleAuthEmail(email!)}>
                            재전송
                        </ActionButton> 
                        :
                        <ActionButton disabled={!cond3} onClick={() => handleAuthEmail(email!)}>
                            인증코드 전송
                        </ActionButton>
                        ) }
            </FormInputContainer>
            {!isEmailVaild && <AlertSpan $isValid={false}>이미 등록된 이메일입니다.</AlertSpan>}
            <ModalLabelWrapper>인증번호</ModalLabelWrapper>
            <FormInputContainer>
                <InputBoxOnBlurChildren
                    type='text'
                    placeholder="인증번호 입력"
                    defaultValue=''
                    onBlur={(e)=>setInputAuthCode(e.target.value)}
                    children={
                    (!authCodeVerify || !authCodeValid) && <CountdownTimer m={5} resetTrigger={resetTimer} setState={setIsTimeout}/>
                    }
                    disabled={authCode.length === 0 || isEmailVerify}
                />
                <ActionButton disabled={isTimeout || isEmailVerify} style={{ padding: '13px 20px' }}onClick={()=>handleEmailVerify()}>
                인증
                </ActionButton>
            </FormInputContainer>
            </ModalInputBoxWrapper>
            <ModalFooterWarpper>
                <ActionButton style={{width:'100%', height:'50px'}} onClick={()=>modalSetField('open',false)}>취소</ActionButton>
                <NextButton disabled={!isEmailVerify} onClick={handleChangeEmail}>이메일 변경</NextButton>
            </ModalFooterWarpper>
        </ModalContentWrapper>
    )
}

export default AdChangeEmailModalContent